module.exports = __webpack_public_path__ + "img/universeSoft.b65e5ada.png";